import { RealEstate } from '../../../../@types/real-estate-api-types'
import { ContentStateInterface } from '../../../../@types/types'

export const rentDurationsToApp = (listing: RealEstate, defaultStateValues: ContentStateInterface) => ({
  monthly: listing.details?.rentDurations?.MONTHLY ?? defaultStateValues.rentDurations?.monthly ?? false,
  weekly: listing.details?.rentDurations?.WEEKLY ?? defaultStateValues.rentDurations?.weekly ?? false,
  longTerm: listing.details?.rentDurations?.LONG_TERM ?? defaultStateValues.rentDurations?.longTerm ?? false,
  yearly: listing.details?.rentDurations?.YEARLY ?? defaultStateValues.rentDurations?.yearly ?? false,
})
